module.exports = __webpack_public_path__ + "static/img/img_little.c52b862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_little.png
// module id = sr5M
// module chunks = 1